import { MergeLinkOrganizationCustomizationData } from "../config/types";
import CustomGlobalStyle from "./CustomGlobalStyle";
import { getCssFontFamily } from "../utils/customizationUtils";

type Props = {
  orgCustomization?: MergeLinkOrganizationCustomizationData | null;
};

const CustomGlobalStyleWrapper = ({ orgCustomization }: Props) => {
  if (!orgCustomization) return null;

  return (
    <CustomGlobalStyle
      font={getCssFontFamily(orgCustomization?.font ?? null)}
      buttonColor={orgCustomization?.primary_button_color}
      buttonTextColor={orgCustomization?.primary_button_text_color}
      buttonBorderRadius={orgCustomization?.button_border_radius}
      selectionButtonBorderRadius={orgCustomization?.selection_button_border_radius}
      modalBorderRadius={orgCustomization?.modal_border_radius}
    />
  );
};

export default CustomGlobalStyleWrapper;
